import classnames from "classnames";
import * as I from "immutable";
import ImmutablePropTypes from "react-immutable-proptypes";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";

import {trackEvent} from "metrics";

import api from "v2/api";
import {Route} from "v2/api/Records";

import RouteSelect from "v2/components/RouteSelect";

import ModalForm from "v2/components/responsive/ModalForm";

export default class SendHelpForm extends Component {
  static contextTypes = {
    dateData: ImmutablePropTypes.listOf(Route),
    location: PropTypes.object,
    onUpdateDateData: PropTypes.func,
    onUpdateRouteData: PropTypes.func,
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
      routeId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
    router: PropTypes.object,
  }

  static propTypes = {
    modal: PropTypes.bool,
    onCancel: PropTypes.func,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedRoute: null,
      errors: I.Map(),
    };
  }

  handleSelectChange = (item) => {
    this.setState({
      selectedRoute: item && item.value,
    });
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    this.setState({
      submitted: true,
    });

    const {
      location: {query},
      onUpdateDateData,
      onUpdateRouteData,
      params: {date, routeId},
      router,
    } = this.context;
    const {modal, onCancel} = this.props;
    const {selectedRoute} = this.state;

    api()
      .post(this.apiUrl, {
        "help_route": selectedRoute,
      })
      .then(() => {
        onUpdateRouteData(null, () => {
          modal && onCancel();

          router.push({
            pathname: `/${date}/${selectedRoute}`,
            query,
          });

          trackEvent("Send Help", ["Route", "Send Help", routeId], {
            Date: date,
            ID: routeId,
          });

          onUpdateDateData();
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          const {data} = err.response;
          this.setState({
            errors: Array.isArray(data) ? I.Map({message: data[0]}) : I.Map(data),
            submitted: false,
          });
        } else {
          this.setState({
            errors: I.Map({
              message: "Server Error. Please contact engineering team if error will repeat after page reload.",
            }),
            submitted: false,
          });
          Raven.captureException(err);
        }
      });
  }

  get apiUrl() {
    const {params: {routeId, id}} = this.context;
    return `/routes/${routeId}/destinations/${id}/temporary-help`;
  }

  renderContent() {
    const {selectedRoute, errors} = this.state;

    let serverError;
    if (errors.get("message")) {
      serverError = (
        <div className={classnames("text-danger")}>
          {errors.get("message")}
        </div>
      );
    }

    return (
      <div className="form-horizontal">
        <RouteSelect
          error={errors.get("helpRoute")}
          fieldContainerClassName="col-xs-12 col-sm-9"
          focus
          labelClassName="col-xs-12 col-sm-3 control-label"
          onChange={this.handleSelectChange}
          selected={selectedRoute} />

        {serverError}
      </div>
    );
  }

  render() {
    const {submitted} = this.state;
    return (
      <ModalForm
        btnSubmitDisabled={submitted}
        btnSubmitLabel="Send Help"
        modalTitle="Send Help"
        onSubmit={this.handleSubmit}
        pageTitle="Send Help"
        {...this.props}>
        {this.renderContent()}
      </ModalForm>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/SendHelpForm.js
 **/